<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Get Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="6" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        hint="Please select academic year" @click="show = false;registration_no = null;" />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" return-object label="Semester" persistent-hint
                        hint="Please select semester" @change="getStud()" @click="show = false" />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete v-model="registration_no" rounded color="#0F2027" :items="stud_list"
                        label="Select Student" item-text="name" item-value="registration_number" outlined dense
                        @click="show = false" />
                </v-col>
                <!-- <v-col cols="12" sm="6" md="2" v-if="sel_ay_data && sem && registration_no">
                    <v-btn class="mt-6 button" @click="getreport()">Fetch / Generate</v-btn>
                </v-col> -->

                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && registration_no && sem.name=='Annual'">
                    <v-btn v-if="sem.name=='Annual'" class="mt-6 button" @click="viewreport()">View Marksheet</v-btn>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && registration_no && sem.name!='Annual'">
                    <v-btn class="mt-6 button" @click="getreport()">Fetch / Generate </v-btn>
                </v-col>
                <!-- <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && registration_no && sem">
                    <v-btn class="mt-6 button" @click="getreport()">Fetch / Generate </v-btn>
                </v-col> -->
            </v-row>
        </v-card>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Get Student Report Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/JmcDpNGmDrA?si=oaRlQ-RO6AT5vGN7"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                default_value: [],
                dialog_marks: false,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                overlay: false,
                selected: [],
                snackbar: false,
                videoDialog:false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                registration_no: null,
                father_full_name: null,
                leraner_marksheet: [],
                semester: null,
            };
        },

        methods: {
            viewreport(){
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("setreg_no", this.registration_no);
                this.show = true;
                let routeData = this.$router.resolve({ name: "learner-annual-marksheet-icse-pre-prim-view" });
                window.open(routeData.href, "_blank");
            },
            getreport() {
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("setreg_no", this.registration_no);
                this.show = true;
                if(this.sem.name=='Annual'){
                let routeData = this.$router.resolve({ name: "learner-annual-marksheet-icse-pre-prim-print" });
                window.open(routeData.href, "_blank");
                }else{
                    let routeData = this.$router.resolve({ name: "learner-marksheet-icse-pre-prim-print" });
                window.open(routeData.href, "_blank");
                }
                // let routeData = this.$router.resolve({ name: "learner-marksheet-icse-pre-prim-print" });
                // window.open(routeData.href, "_blank");
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStud() {
                (this.stud_list = []), (this.registration_no = null);
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                axios
                    .post("/AccountingAndFees/getChildList_for_marksheet", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if ((res.data.status = "SUCCESS")) {
                                this.stud_list = res.data.learners;
                            } else {
                                alert(res.data.status_reason);
                            }
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
            this.awspath = localStorage.getItem("awspath");
        },
    };
</script>
<style scoped>
    .text_report {
        border: 3px solid black;
        margin: 1rem !important;
    }
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        .card {
            border: none !important;
            font-size: large !important;
        }
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: large !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        thead {
            font-weight: bold !important;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    ol.s {
        list-style-type: inherit;
    }
</style>
